import { render } from "./CurrentCompany.vue?vue&type=template&id=0d7f4bbb"
import script from "./CurrentCompany.vue?vue&type=script&lang=js"
export * from "./CurrentCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__